import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../utils/index.js";
import { textVariants } from "../../variants/index.js";
const Span_Span = /*#__PURE__*/ forwardRef(function({ children, className, ...props }, ref) {
    const classes = cn(textVariants(props), className);
    return /*#__PURE__*/ jsx("span", {
        ref: ref,
        className: classes,
        children: children
    });
});
export { Span_Span as Span };
